<div class="row"> 
    <div class="col-12">
        <img src="assets/nyvus/logo_nyvus.svg">
    </div>
</div>
<div class="row">
    <div class="col-xl-12">
        <!-- <mat-icon style="float: left;margin-right: 10px;margin-top: 3px;" [style.color]="data.icono.color">
            {{data.icono.simbolo}}</mat-icon> -->
            <div style="
            padding: 10px 0px 10px 0px;
            font-size: 20px;
            text-align: center;
            margin: 10px;
            font-weight: 400;
            border-bottom: 1px solid #dadada;
            color: #333333;
        "> Sesión Expirada </div>
    </div>
</div>
<div mat-dialog-content style="overflow: visible;">
    <p>Por favor, Reingrese sus credenciales</p>
    <div class="row">
        <div class="col-12">
            <mat-form-field class="full-width">
                <input matInput placeholder="Usuario" autocomplete="username" (keyup.Enter)="ingresar()" [(ngModel)]="username">
            </mat-form-field>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <mat-form-field class="full-width">
                <input matInput type="password" autocomplete="current-password" placeholder="Contraseña" (keyup.Enter)="ingresar()" [(ngModel)]="password">
            </mat-form-field>
        </div>
    </div>
    <div class="row">
            <div class="col-12">
                <p style="color:#f44336">{{error}}</p>
            </div>
        </div>
</div>
<div mat-dialog-actions>    
    <button mat-button  [mat-dialog-close]="false"
        tabindex="-1" (click)="desconectarse()">Desconectarse</button>
    <button mat-button color="primary"
        tabindex="2" (click)="ingresar()">Ingresar</button>
</div>